let compare = (a, b, type) => {
  "use strict";

  switch (type) {
    case 'number':
      if (isNaN(a) && !isNaN(b)) {
        return 1;
      } else if (!isNaN(a) && isNaN(b)) {
        return -1;
      }
  }
  if (a < b) {
    return -1;
  }
  if (a === b) {
    return 0;
  }
  if (a > b) {
    return 1;
  }
  return null;
};

module.exports = compare;


// WEBPACK FOOTER //
// ./app.v2/assets/js/compare.js